import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal } from 'antd';

import Score from '../student/student/Score';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  classCode: string|undefined;
  memberCode: string;
}

const ShowScoreModal: FC<IProps> = ({
  visible,
  setVisible,
  classCode,
  memberCode,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t('class.class.column35')}
      visible={visible}
      width={900}
      onCancel={() => setVisible(false)}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={() => setVisible(false)}
          >
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      <Score
        defaultClassCode={classCode}
        memberCode={memberCode}
      />
    </Modal>
  );
};

export default ShowScoreModal;
